import { render, staticRenderFns } from "./join.vue?vue&type=template&id=7c8d2ce8&"
var script = {}
import style0 from "./join.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "join.vue"
export default component.exports